import { Link } from "react-router-dom";
import type { Movie } from "@/types/movie";

interface HotRankingProps {
  items: Movie[];
}

export default function HotRanking({ items }: HotRankingProps) {
  return (
    <section className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex items-center justify-between">
        <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
          <i className="ri-fire-fill text-lg text-accent-500" aria-hidden="true" />
          热播榜 TOP5
        </h2>
        <span className="text-xs text-foreground-500">按播放热度</span>
      </div>

      {items.length === 0 ? (
        <p className="mt-6 text-sm text-foreground-500">暂无相关资源，敬请期待</p>
      ) : (
        <ul className="mt-3 flex flex-1 flex-col divide-y divide-background-200">
          {items.map((movie, i) => (
            <li key={movie.id} className="flex-1">
              <Link
                to={`/detail/${movie.id}`}
                className="flex items-center gap-3 py-2.5 transition-colors hover:text-primary-600"
              >
                <span
                  className={`w-5 shrink-0 text-center font-heading text-base font-bold ${
                    i < 3 ? "text-accent-500" : "text-foreground-400"
                  }`}
                >
                  {i + 1}
                </span>
                <div className="h-14 w-10 shrink-0 overflow-hidden rounded-md bg-background-200">
                  <img
                    src={movie.cover}
                    alt={`${movie.title} 海报`}
                    title={`${movie.title} - 热播榜`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm font-medium text-foreground-900">{movie.title}</p>
                  <p className="mt-0.5 truncate text-xs text-foreground-500">
                    {movie.type} · {movie.year} · {movie.genres[0]}
                  </p>
                </div>
                <span className="shrink-0 font-label text-sm font-bold text-accent-600">
                  {movie.rating.toFixed(1)}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}